import axios from 'axios';

const state = {
  alerts: null,
};

const getters = {
  getReducedAlertsSet: st => st.alerts.slice(0, 4),
};

const actions = {
  async getAlerts({ commit }) {
    await axios.get(`${process.env.VUE_APP_CRISIS_API2}?siteType=partners`, {
      headers: {
        'Access-Control-Allow-Origin': '*',
        Accept: 'application/json',
      },
    }).then((response) => {
      commit('SET_ALERTS', response.data);
    });
  },
};

const mutations = {
  SET_ALERTS(st, alerts) {
    st.alerts = alerts;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
